var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{staticClass:"mt-2"},[_c('crowd-fundraising-form',{attrs:{"submit-functions":{
        submitCrowdFund:_vm.submitMainInfo,
        addCrowdFundLocation: _vm.addCrowdFundLocation,
        addCrowdFundPlan: _vm.addCrowdFundPlan,
        addCrowdFundMedia: _vm.addCrowdFundMedia,
      },"crowdfund":_vm.crowdfund},on:{"update:crowdfund":function($event){_vm.crowdfund=$event}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }